import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "helpers/axiosbaseQuery";
import { VITE_API_V2_URL } from "codes";
import type { StatusMaster } from "./api-category-status.d";

export const statusMasterApi = createApi({
  reducerPath: "statusMaster",
  baseQuery: axiosBaseQuery({
    baseUrl: `${VITE_API_V2_URL}`,
  }),
  tagTypes: ["STATUS_MASTER"],
  endpoints: (builder) => ({
    fetchStatusMaster: builder.query<StatusMaster, void>({
      query: () => ({
        url: "/commons-statuses-category",
        method: "get",
      }),
      transformResponse: (response: { data: StatusMaster }) => response.data,
      providesTags: ["STATUS_MASTER"],
    }),
  }),
});

export const { useFetchStatusMasterQuery } = statusMasterApi;
